"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../../../../../common/utils");

require("../styles/_clip-comments.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function getCommentTitle(comment) {
  return (0, _utils.convertSecondsToReadable)(comment.timestamp);
}

function getPreview(clip) {
  var isTempClipId = clip.clipId.includes('clip-');

  if (!clip.isImage) {
    return /*#__PURE__*/_react.default.createElement(_commonReact.Player, {
      assetId: clip.assetId,
      selectedClip: clip,
      showComments: !isTempClipId,
      filterByClipId: true
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "clip-comments__image-preview"
  }, !isTempClipId ? /*#__PURE__*/_react.default.createElement(_commonReact.CommentsOverlay, {
    selectedClip: clip,
    selector: ".clip-comments__image-preview > .comments-overlay",
    isPlaying: false,
    time: 0,
    totalDuration: 0,
    pauseTime: Function.prototype,
    setCustomTime: Function.prototype,
    filterByClipId: true,
    hideIndicators: true
  }) : null, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
    assetId: clip.assetId,
    height: "100%",
    width: "100%",
    hideFileTypeIcon: true,
    darkMode: true,
    borderRadius: 6
  }));
}

var ClipComments = /*#__PURE__*/function (_React$Component) {
  _inherits(ClipComments, _React$Component);

  var _super = _createSuper(ClipComments);

  function ClipComments() {
    _classCallCheck(this, ClipComments);

    return _super.apply(this, arguments);
  }

  _createClass(ClipComments, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          clipId = _this$props.clipId,
          clips = _this$props.clips,
          history = _this$props.history,
          pathname = _this$props.location.pathname;
      var currentClipIndex = clips.findIndex(function (clip) {
        return clip.clipId === clipId;
      });
      var clip = clips[currentClipIndex];
      var isTempClipId = clipId.includes('clip-');
      var previousClipId = (0, _lodash.default)(clips[currentClipIndex - 1], 'clipId');
      var nextClipId = (0, _lodash.default)(clips[currentClipIndex + 1], 'clipId');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments column"
      }, clip && !isTempClipId && /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__left-column"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__header__info"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "info",
        color: "regent",
        size: 20
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true,
        noMargin: true
      }, "Add a comment by clicking anywhere on the clip preview below")), /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__header__arrows"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        prefix: "chevronleft",
        disabled: currentClipIndex === 0,
        onClick: function onClick() {
          return history.push("".concat(pathname, "?commentclip=").concat(previousClipId, "#1"));
        }
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        prefix: "chevronright",
        disabled: currentClipIndex === clips.length - 1,
        onClick: function onClick() {
          return history.push("".concat(pathname, "?commentclip=").concat(nextClipId, "#1"));
        }
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__content"
      }, !clip || isTempClipId ? /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__not-found"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        size: 55,
        name: "comments",
        color: "regent"
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading3: true,
        centered: true
      }, 'This clip doesn\'t exist'), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        placeholder: true,
        centered: true
      }, 'Try going back to the project with the \'Back To Project\' button below and selecting a clip.')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__left-column"
      }, getPreview(clip)), /*#__PURE__*/_react.default.createElement("div", {
        className: "clip-comments__right-column clip-comments__comments-container"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.CommentsTab, {
        hideFilter: true,
        selectedClipId: clip.clipId,
        emptySubtitle: "Add a comment by clicking anywhere on the video player",
        isVideoReview: true,
        getCommentTitle: getCommentTitle
      })))));
    }
  }]);

  return ClipComments;
}(_react.default.Component);

exports.default = ClipComments;